import {Choice, OptionType, Separator} from 'platform/components';
import {Box, HStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {KanbanFilters as KanbanFiltersType} from '../types/KanbanFilters';
import {LastUpdated} from '../types/LastUpdated';
import {ScheduledDaysPeriod} from '../types/ScheduledDaysPeriod';

const lastUpdatedAtOptions: OptionType<LastUpdated>[] = [
  {label: i18n.t('page.rentalOrder.labels.lastWeek'), value: 7},
  {label: i18n.t('page.rentalOrder.labels.lastTwoWeeks'), value: 14},
  {label: i18n.t('page.rentalOrder.labels.lastMonth'), value: 30},
  {label: i18n.t('page.rentalOrder.labels.lastTwoMonths'), value: 60},
];

const scheduledDaysOptions: OptionType<ScheduledDaysPeriod>[] = [
  {label: i18n.t('page.rentalOrder.labels.sevenDaysPeriod'), value: 7},
  {label: i18n.t('page.rentalOrder.labels.fourteenDaysPeriod'), value: 14},
  {label: i18n.t('page.rentalOrder.labels.thirtyDaysPeriod'), value: 30},
];

export function KanbanFilters(props: KanbanFiltersType) {
  return (
    <>
      <Separator spacing={0} />
      <Box width="100%" paddingVertical={4}>
        <HStack spacing={2}>
          <Box minWidth={75}>
            <Choice
              value={props.scheduledRentDaysPeriod}
              options={scheduledDaysOptions}
              onChange={props.setScheduledRentDaysPeriod}
              menuInPortal
              label={i18n.t('page.rentalOrder.labels.scheduledRentDaysPeriod')}
            />
          </Box>
          <Box minWidth={75}>
            <Choice
              value={props.scheduledReturnDaysPeriod}
              options={scheduledDaysOptions}
              onChange={props.setScheduledReturnDaysPeriod}
              menuInPortal
              label={i18n.t('page.rentalOrder.labels.scheduledReturnDaysPeriod')}
            />
          </Box>
          <Box minWidth={75}>
            <Choice
              value={props.lastUpdated}
              options={lastUpdatedAtOptions}
              onChange={props.setLastUpdated}
              menuInPortal
              label={i18n.t('page.rentalOrder.labels.lastUpdated')}
            />
          </Box>
        </HStack>
      </Box>
    </>
  );
}
